import config from "appConfig";
import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";

export const component: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/23/principle/table.svg`,
        },
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      text: "Sound sample",
      icon: "cis-volume-high",
      shape: "round",
      theme: "secondary",
      url: `${config.ASSETS_URL}/01/23/principle/table.wav`,
    },
  },
];
